module.exports = __webpack_public_path__ + "img/blue_logo_bg.70b8a91c.png";